import React, { createContext, useState, useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import apiPath from "../constants/apiPath";
import axios from "axios";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({ token: null });
  const [isAdmin, setIsAdmin] = useState(true);
  const [userProfile, setUserProfile] = useState();

  const fetchUser = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(apiPath.baseURL + `${apiPath.profile}`, {
        headers,
      });
      setUserProfile(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    if (!token) return;

    const storedUser = localStorage.getItem("userProfile");

    let user = null;
    try {
      user = storedUser ? JSON.parse(storedUser) : null;
    } catch (e) {
      console.warn("Invalid userProfile in localStorage:", storedUser);
      localStorage.removeItem("userProfile"); // clear corrupted value
    }

    if (user) {
      fetchUser();
      // setUserProfile(user) // optional: use cached profile
    }

    setIsLoggedIn(true);
    setSession({ token: token });
  }, []);

  useEffect(() => {
    if (!userProfile) return;
    if (userProfile.type == "SubAdmin") {
      setIsAdmin(false);
    }
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/dashboard" />;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userProfile");
    setIsLoggedIn(false);
    setSession({ token: null });
    setUserProfile();
    // ShowToast("Logout Successfully", Severty.SUCCESS);
    return <Navigate to="/" />;
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        login,
        logout,
        isAdmin,
        setIsAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};
